import { EVENTS } from '@archetype-themes/utils/events'

class BlockPrice extends HTMLElement {
  constructor() {
    super()

    this.handleVariantChange = this.handleVariantChange.bind(this)
  }
  connectedCallback() {
    this.abortController = new AbortController()

    document.addEventListener(
      `${EVENTS.variantChange}:${this.dataset.sectionId}:${this.dataset.productId}`,
      this.handleVariantChange,
      { signal: this.abortController.signal }
    )
  }

  disconnectedCallback() {
    this.abortController.abort()
  }
  updateRewardPoints(varPrice) {
    const pointsContainer = document.querySelector(".product__points");
    if (pointsContainer) {
      const originalText = pointsContainer?.textContent || "";

      const valuePattern = /\bX\b|\b\d+(\.\d+)?\b/;

      if (valuePattern.test(originalText)) {
        if (varPrice) {
          const variantPrice = varPrice / 100;
          const rewardPointsValue = variantPrice * 5;

          const newText = originalText.replace(valuePattern, rewardPointsValue);
          pointsContainer.textContent = newText;
        }
      }
    }
  }
  handleVariantChange({ detail }) {
    const { html, variant } = detail

    if (!variant) {
      return
    }

    const priceSource = html.querySelector(`block-price[data-section-id="${this.dataset.sectionId}"] div`)
    const priceDestination = this.querySelector('div')

    if (priceSource && priceDestination) {
      priceDestination.outerHTML = priceSource.outerHTML
       this.updateRewardPoints(variant.price);
    }
  }
}

customElements.define('block-price', BlockPrice)
